<template>
  <div class="form-group form-row">
    <label :for="safeId('albumId')" class="col-sm-4 col-form-label">{{ label }}</label>
    <div class="col-sm-8">
      <album-select :id="safeId('albumId')" v-model="localValue"></album-select>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'album-select-group',
    props: {
      value: {required: true},
      label: {default: 'Album'}
    },
    data () {
      return {
        localValue: this.value
      }
    },
    watch: {
      localValue: function (val) {
        this.$emit('input', val)
      },
      value: function (val) {
        this.localValue = val
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ui/album-select-group.vue